/* global loadjs */

  $('#tracking_info, #track_flash').empty().hide();
  $('#track_order_form').validate();
  $('#track_order_form').submit(function () {
    $('.required-error').hide();

    if ($('#track_order_form').valid()) {
      $('#tracking_info, #track_flash').empty().hide();
      $('#loading-overlay').show();
      var signature = encryptParam("{tracking:'".concat($('#tracking_number').val(), "',time:").concat(new Date().getTime(), "}"));
      $.ajax({
        url: "".concat(apiEndpoint, "/track_order.js"),
        type: 'GET',
        dataType: 'script',
        timeout: 20000,
        beforeSend: function beforeSend() {
          $('#track_order_form button.btn-primary').attr('disabled', 'disabled').text('Tracking...');
        },
        data: {
          order_number: $('#tracking_number').val(),
          brand_name: '{{settings.tracking_store}}',
          signature: signature
        },
        success: function success() {
          $('#track_order_form button.btn-primary').text('Track Order').removeAttr('disabled');
          $('#loading-overlay').hide();
        },
        error: function error() {
          $('#track_order_form button.btn-primary').text('Track Order').removeAttr('disabled');
          $('#loading-overlay').hide();
          $('#track_flash').html('Oops! We are not able to find info at this time please try again after some time').addClass('alert alert-error').show().delay(5000).fadeOut();
        }
      });
    } else {
      $('.required-error').show();
      return false;
    }

    return false;
  });
  var splitter = window.location.href.split('?');

  if (splitter.length > 1) {
    var params = splitter[splitter.length - 1];
    var params_split = params.split('&');
    params_split.forEach(function (el) {
      if (el.indexOf('trackingNumber') !== -1) {
        var arr = el.split('=');
        var tracking = arr[arr.length - 1];

        if (tracking) {
          $('#tracking_number').val(tracking);
          setTimeout(function () {
            $('#track_order_form').submit();
          }, 200);
        }
      }
    });
  }
